import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import { Grid } from "@mui/material";

import { others, colors } from "../../styles/colors";
import { EmailTextStyle, ErrorBox, GridItem, GridLayout } from "../styles/styles";
import { clientServiceEmail } from "../../constants/Config";

const UnAuthorizedPage = () => {
  return (
    <GridLayout container>
      <Grid size={{ xs: 12, md: 6}} sx={{alignSelf: "center"}}>
      <GridItem>
        <ErrorBox>
          <Typography
            variant="h1"
            color={others.otherColors[10]}
            fontWeight="fontWeightBold"
            fontSize={"2.8em"}
            pt={"1rem"}
          >
            Login error
          </Typography>
          <Typography
            variant="h3"
            color={colors.primary.main}
            fontWeight="500"
            pt={"1rem"}
            pb={"1rem"}
          >
            {"As a health plan user, please sign in through your health plan's website using the Single Sign-On (SSO) link provided there. Direct access to the application is not supported."}
          </Typography>
            <Typography
              variant="h3"
              color={colors.primary.main}
              fontWeight="500"
            >
             If you continue to receive this error please contact
             <Link href={`mailto:${clientServiceEmail}`} sx={EmailTextStyle}>
              {clientServiceEmail}
             </Link>
            </Typography>
        </ErrorBox>
      </GridItem>
       </Grid>
    </GridLayout>
  );
};

export default UnAuthorizedPage;
